$(document).ready(function(){

  $('.size-guide').click(function(){
    $('.product-zhezhao').css("display","block");
  });
  $('.product-zhezhao-XX').click(function(){
    $('.product-zhezhao').css("display","none")
  });

  // $('.lider').bxSlider();
  $('.lider').slick({
    infinite: false,
    vertical:true,
    speed: 300,
    arrows:true,
    // nextArrow:'<button type="button" class="slick-next">Next</button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    focusOnChange: true,
    asNavFor: '.featured_slide',
  });
  $('.featured_slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical:false,
    autoplay: true,
    arrows: false,
    asNavFor: '.lider',
    infinite: false,
    responsive:[
      {
        breakpoint: 767,
        settings: {
          dots: true,
        }
      }
    ]

  })
    $('.slick-prev').css({
      "outline":"none"
    }).html("").append('<img src="//cdn.shopify.com/s/files/1/2590/9042/t/32/assets/xiangshang_25x25.png?v=26178119482587881401523589102" >')
    $('.slick-next').css("outline","none").html("").append('<img src="//cdn.shopify.com/s/files/1/2590/9042/t/32/assets/xiangxia_25x25.png?v=44154255993786515091523589102" >')
    $('.slick-track').children().css("outline","none");

    // .DetailsA
    function shows(jiayi,jiachild1,jiachild2,jiachild3,jia,jian){
      $(jiayi).click(function(){
        if ( $(this).children('.open').css("display") == 'none') {
          $(this).children('.open').css("display","block")
          $(this).children('.packUp').css("display","none")
          $(jiachild).css("display","none");
        }else {
          $(this).children('.open').css("display","none")
          $(this).children('.packUp').css("display","block")
          $(jiachild).css("display","block");
        }
      })
      
    }
    shows('.Details','.Details','.Details-child');
    shows('.Fabric','.Fabric','.Fabric-child');
    shows('.Care','.Care','.Care-child');



    // productRight
  $('.header').css("display","none");
  $('.tooltip').css("display","none");

  $('.Details-child').children('div').removeClass('product-description')

  $('.backgroundColors').html($('.tooltip:eq(0)').html());
  $('.swatch-element:eq(0)').addClass('colorBorder')
  $('.swatch-element').click(function(){
    $(this).children('label').addClass('labels');
    $(this).addClass('colorBorder').siblings().removeClass('colorBorder');
    // $(this).children('colorBorders').addClass('colorBorder').siblings().children('.colorBorders').removeClass('colorBorder')
    var backgroundColors = $(this).find(".tooltip").html();
    $('.backgroundColors').html(backgroundColors);
  });


  $('.swatch:eq(1)').hide();
  $('.swatch:eq(2)').hide();



});
